import { appConfigActionTypes } from '.';
import { Language } from '../../settings/i18n/languages';

// panel nawigacyjny
export const toggleNavPanel = () =>
  ({
    type: appConfigActionTypes.NAV_PANEL_TOGGLE,
  } as const);
export const closeNavPanel = () =>
  ({
    type: appConfigActionTypes.NAV_PANEL_CLOSE,
  } as const);

// język aplikacji
export const setLanguage = (language: Language) =>
  ({
    type: appConfigActionTypes.LANGUAGE_SET,
    payload: { language },
  } as const);

// maintenance mode
export const setMaintenanceMode = (maintenanceList: AppConfig.MaintenanceMode[]) =>
  ({
    type: appConfigActionTypes.MAINTENANCE_MODE_SET,
    payload: { maintenanceList },
  } as const);

// protokoły
export const closeProtocolModal = () =>
  ({
    type: appConfigActionTypes.PROTOCOL_MODAL_CLOSE,
  } as const);
export const openProtocolModal = (poraRoku: Protocol.Basic['poraRoku']) =>
  ({
    type: appConfigActionTypes.PROTOCOL_MODAL_OPEN,
    payload: { poraRoku },
  } as const);

export const generateSingleProtocol = (payload: Protocol.ParamsForSingle) =>
  ({
    type: appConfigActionTypes.PROTOCOL_GENERATE_SINGLE_START,
    payload,
  } as const);
export const generateSingleProtocolSuccess = () =>
  ({
    type: appConfigActionTypes.PROTOCOL_GENERATE_SINGLE_SUCCESS,
  } as const);
export const generateSingleProtocolFail = () =>
  ({
    type: appConfigActionTypes.PROTOCOL_GENERATE_SINGLE_FAIL,
  } as const);

export const generateGroupProtocols = (payload: Protocol.ParamsForGroup) =>
  ({
    type: appConfigActionTypes.PROTOCOL_GENERATE_GROUP_START,
    payload,
  } as const);
export const generateGroupProtocolsSuccess = () =>
  ({
    type: appConfigActionTypes.PROTOCOL_GENERATE_GROUP_SUCCESS,
  } as const);
export const generateGroupProtocolsFail = () =>
  ({
    type: appConfigActionTypes.PROTOCOL_GENERATE_GROUP_FAIL,
  } as const);

export const getProtocolStatus = (payload: Protocol.ParamsForStatus) =>
  ({
    type: appConfigActionTypes.PROTOCOL_GET_STATUS_START,
    payload,
  } as const);
export const getProtocolStatusSuccess = (payload: Protocol.Basic[]) =>
  ({
    type: appConfigActionTypes.PROTOCOL_GET_STATUS_SUCCESS,
    payload,
  } as const);
export const getProtocolStatusFail = () =>
  ({
    type: appConfigActionTypes.PROTOCOL_GET_STATUS_FAIL,
  } as const);

export const getPdf = (protId: Protocol.Basic['protId']) =>
  ({
    type: appConfigActionTypes.PROTOCOL_PDF_GET_START,
    payload: { protId },
  } as const);
export const getPdfSuccess = (protId: Protocol.Basic['protId'], data: string) =>
  ({
    type: appConfigActionTypes.PROTOCOL_PDF_GET_SUCCESS,
    payload: { protId, data },
  } as const);
export const getPdfFail = (protId: Protocol.Basic['protId']) =>
  ({
    type: appConfigActionTypes.PROTOCOL_PDF_GET_FAIL,
    payload: { protId },
  } as const);
export const downloadProtocol = (protId: Protocol.Basic['protId']) =>
  ({
    type: appConfigActionTypes.PROTOCOL_PDF_DOWNLOAD_START,
    payload: { protId },
  } as const);
export const downloadProtocolSuccess = (protId: Protocol.Basic['protId']) =>
  ({
    type: appConfigActionTypes.PROTOCOL_PDF_DOWNLOAD_SUCCESS,
    payload: { protId },
  } as const);
export const downloadProtocolFail = (protId: Protocol.Basic['protId']) =>
  ({
    type: appConfigActionTypes.PROTOCOL_PDF_DOWNLOAD_FAIL,
    payload: { protId },
  } as const);
export const printOutProtocol = (protId: Protocol.Basic['protId']) =>
  ({
    type: appConfigActionTypes.PROTOCOL_PDF_PRINT_OUT_START,
    payload: { protId },
  } as const);
export const printOutProtocolSuccess = (protId: Protocol.Basic['protId']) =>
  ({
    type: appConfigActionTypes.PROTOCOL_PDF_PRINT_OUT_SUCCESS,
    payload: { protId },
  } as const);
export const printOutProtocolFail = (protId: Protocol.Basic['protId']) =>
  ({
    type: appConfigActionTypes.PROTOCOL_PDF_PRINT_OUT_FAIL,
    payload: { protId },
  } as const);

// historia ocen
export const openChangeLogModal = (kodPrzedmiotu: Przedmiot['przedmiotKod'], kartaPrzedmiotId: StudentsData['kartaOcenId']) =>
  ({
    type: appConfigActionTypes.CHANGE_LOG_MODAL_OPEN,
    payload: { kodPrzedmiotu, kartaPrzedmiotId },
  } as const);
export const closeChangeLogModal = () =>
  ({
    type: appConfigActionTypes.CHANGE_LOG_MODAL_CLOSE,
  } as const);
export const getChangeLogSuccess = (data: Modal.ChangeLog['data']) =>
  ({
    type: appConfigActionTypes.CHANGE_LOG_DATA_GET_SUCCESS,
    payload: { data },
  } as const);
export const getChangeLogFail = () =>
  ({
    type: appConfigActionTypes.CHANGE_LOG_DATA_GET_FAIL,
  } as const);

// parowanie efektów kierunkowych
export const openPairEffectsModal = (data: Modal.PairEffectsData, tabId: DynamicTabComponent['id']) =>
  ({
    type: appConfigActionTypes.PAIR_EFFECTS_MODAL_OPEN,
    payload: { data, tabId },
  } as const);
export const closePairEffectsModal = () =>
  ({
    type: appConfigActionTypes.PAIR_EFFECTS_MODAL_CLOSE,
  } as const);
export const savePairedEffects = () =>
  ({
    type: appConfigActionTypes.PAIR_EFFECTS_SAVE_START,
  } as const);
export const savePairedEffectsFail = () =>
  ({
    type: appConfigActionTypes.PAIR_EFFECTS_SAVE_FAIL,
  } as const);
export const selectCardLanguage = (lang: string) =>
  ({
    type: appConfigActionTypes.PAIR_EFFECTS_SELECT_CARD_LANGUAGE,
    payload: { lang },
  } as const);
export const selectCardVersion = (version: string) =>
  ({
    type: appConfigActionTypes.PAIR_EFFECTS_SELECT_CARD_VERSION,
    payload: { version },
  } as const);
export const changeSelectProgramOpen = (opened: boolean) =>
  ({
    type: appConfigActionTypes.CHANGE_SELECT_PROGRAM_OPEN,
    payload: { opened },
  } as const);
export const selectStudyProgram = (program: string) =>
  ({
    type: appConfigActionTypes.PAIR_EFFECTS_SELECT_STUDY_PROGRAM,
    payload: { program },
  } as const);
export const getStudyPrograms = () =>
  ({
    type: appConfigActionTypes.PAIR_EFFECTS_GET_STUDY_PROGRAMS,
  } as const);
export const getStudyProgramsSuccess = (data: any[]) =>
  ({
    type: appConfigActionTypes.PAIR_EFFECTS_GET_STUDY_PROGRAMS_SUCCESS,
    payload: { data },
  } as const);
export const getStudyProgramsFail = () =>
  ({
    type: appConfigActionTypes.PAIR_EFFECTS_GET_STUDY_PROGRAMS_FAIL,
  } as const);
export const getLearningEffects = () =>
  ({
    type: appConfigActionTypes.PAIR_EFFECTS_GET_LEARNING_EFFECTS_START,
  } as const);
export const getLearningEffectsSuccess = (data: AppConfig.LearningEffect[]) =>
  ({
    type: appConfigActionTypes.PAIR_EFFECTS_GET_LEARNING_EFFECTS_SUCCESS,
    payload: { data },
  } as const);
export const getLearningEffectsFail = () =>
  ({
    type: appConfigActionTypes.PAIR_EFFECTS_GET_LEARNING_EFFECTS_FAIL,
  } as const);
export const getAlreadyPairedEffects = () =>
  ({
    type: appConfigActionTypes.PAIR_EFFECTS_GET_ALREADY_PAIRED_EFFECTS_START,
  } as const);
export const getAlreadyPairedEffectsSuccess = (data: any[]) =>
  ({
    type: appConfigActionTypes.PAIR_EFFECTS_GET_ALREADY_PAIRED_EFFECTS_SUCCESS,
    payload: { data },
  } as const);
export const getAlreadyPairedEffectsFail = () =>
  ({
    type: appConfigActionTypes.PAIR_EFFECTS_GET_ALREADY_PAIRED_EFFECTS_FAIL,
  } as const);
export const selectLearningEffects = (data: number[]) =>
  ({
    type: appConfigActionTypes.PAIR_EFFECTS_SELECT_LEARNING_EFFECTS,
    payload: { data },
  } as const);
export const openRealizatorzyModal = () =>
  ({
    type: appConfigActionTypes.REALIZATORZY_MODAL_OPEN,
  } as const);
export const closeRealizatorzyModal = () =>
  ({
    type: appConfigActionTypes.REALIZATORZY_MODAL_CLOSE,
  } as const);
export const getRealizatorzyListSuccess = (data: any[]) =>
  ({
    type: appConfigActionTypes.REALIZATORZY_GET_LIST_SUCCESS,
    payload: { data },
  } as const);
export const getRealizatorzyListFail = () =>
  ({
    type: appConfigActionTypes.REALIZATORZY_GET_LIST_FAIL,
  } as const);
export const selectRealizatorzy = (selectedData: number[]) =>
  ({
    type: appConfigActionTypes.REALIZATORZY_SELECT,
    payload: { selectedData },
  } as const);

// kopiowanie karty przedmiotu
export const copySubjectCard = () =>
  ({
    type: appConfigActionTypes.COPY_SUBJECT_CARD_START,
  } as const);
export const copySubjectCardSuccess = () =>
  ({
    type: appConfigActionTypes.COPY_SUBJECT_CARD_SUCCESS,
  } as const);
export const copySubjectCardFail = () =>
  ({
    type: appConfigActionTypes.COPY_SUBJECT_CARD_FAIL,
  } as const);
export const openCopySubjectCardModal = (przedmiotId: Przedmiot['przedmiotId'], tabId: DynamicTabComponent['id']) =>
  ({
    type: appConfigActionTypes.COPY_SUBJECT_CARD_MODAL_OPEN,
    payload: { przedmiotId, tabId },
  } as const);
export const closeCopySubjectCardModal = () =>
  ({
    type: appConfigActionTypes.COPY_SUBJECT_CARD_MODAL_CLOSE,
  } as const);
export const selectCardToBeCopied = (id: SubjectCardData['przedmiotId']) =>
  ({
    type: appConfigActionTypes.COPY_SUBJECT_CARD_SELECT,
    payload: { id },
  } as const);
export const setCopyCardsSearch = (searchPhrase: string) =>
  ({
    type: appConfigActionTypes.COPY_SUBJECT_CARD_SET_SEARCH,
    payload: { searchPhrase },
  } as const);
export const getSubjectsCardsListToModal = () =>
  ({
    type: appConfigActionTypes.COPY_SUBJECT_CARD_GET_LIST_START,
  } as const);
export const getSubjectsCardsListToModalSuccess = (data: SubjectCardData[]) =>
  ({
    type: appConfigActionTypes.COPY_SUBJECT_CARD_GET_LIST_SUCCESS,
    payload: { data },
  } as const);
export const getSubjectsCardsListToModalFail = () =>
  ({
    type: appConfigActionTypes.COPY_SUBJECT_CARD_GET_LIST_FAIL,
  } as const);

// kopiowanie ocen końcowych
export const openCopyFinalMarksModal = () =>
  ({
    type: appConfigActionTypes.COPY_FINAL_MARKS_MODAL_OPEN,
  } as const);
export const closeCopyFinalMarksModal = () =>
  ({
    type: appConfigActionTypes.COPY_FINAL_MARKS_MODAL_CLOSE,
  } as const);
export const getStudentsToCopyFinalMarkModal = (tabId: DynamicTabComponent['id']) =>
  ({
    type: appConfigActionTypes.COPY_FINAL_MARKS_MODAL_GET_STUDENTS,
    payload: { tabId },
  } as const);
export const setStudentsInCopyFinalMarkModal = (
  data: SingleObjectDataStructure[],
  selected?: StudentsData['studentId'],
  studentsWithoutOcenaWyliczona?: number,
  studentsWithManuallySignedFinalMark?: number,
  studentsWithMarksByAnotherCounter?: number,
) =>
  ({
    type: appConfigActionTypes.COPY_FINAL_MARKS_MODAL_SET_STUDENTS_IN_STATE,
    payload: {
      data,
      selected,
      studentsWithManuallySignedFinalMark,
      studentsWithoutOcenaWyliczona,
      studentsWithMarksByAnotherCounter,
    },
  } as const);
export const setPrzedmiotInCopyFinalMarkModal = (tabId: DynamicTabComponent['id'], data: AppConfig.CopyFinalMarkPrzedmiotData) =>
  ({
    type: appConfigActionTypes.COPY_FINAL_MARKS_MODAL_SET_PRZEDMIOT_IN_STATE,
    payload: { tabId, data },
  } as const);
export const copyFinalMarksFail = (hash?: string) =>
  ({
    type: appConfigActionTypes.COPY_FINAL_MARKS_FAIL,
    payload: { hash },
  } as const);

// przeniesienie do panelu admina
export const redirectToAdminPanel = () =>
  ({
    type: appConfigActionTypes.REDIRECT_TO_ADMIN_PANEL,
  } as const);

// zapytanie o status api
export const checkApiStatus = () =>
  ({
    type: appConfigActionTypes.CHECK_API_STATUS,
  } as const);
export const checkApiStatusFinish = () =>
  ({
    type: appConfigActionTypes.CHECK_API_STATUS_FINISH,
  } as const);

// akcje związane z notyfikacjami z panelu admina
export const getNotificationListAdmin = (userId: string) =>
  ({
    type: appConfigActionTypes.GET_NOTIFICATION_LIST_ADMIN,
    payload: { userId },
  } as const);
export const getNotificationListAdminFinish = (notificationList: AppConfig.NotificationAdmin[]) =>
  ({
    type: appConfigActionTypes.GET_NOTIFICATION_LIST_ADMIN_FINISH,
    payload: { notificationList },
  } as const);
